import React, { Component } from 'react';
import api from '../../../lib/api';

import {
  CompanyKycDetailsContainer,
  Title,
  FormSection,
  InputSection,
  DetailsOfInput,
  InputTitle,
  InputFieldWithSubmit,
  Input,
  DisplayStatusSection,
  KycStatus,
  KycStatusDisplay,
  KycStatusTitle,
  KycStatusDetails,
  ScanChequeImage,
  ActionButtons,
  GetCompanyKycButton,
  VerifyKycButton,
  UnverifyKycButton,
  ResultSection
} from './styles';

class CheckKycStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyId: '',
      operationInProgress: false,
      kycStatus: undefined,
      kycData: null,
      razorpayBankAccount: null,
      error: false,
      errorMessage: ''
    };
  }

  updateValue = event => {
    event.preventDefault();
    const updatedState = { ...this.state };
    updatedState[event.target.name] = event.target.value.trim();
    this.setState(updatedState);
  };

  getCompanyKycDetails = async () => {
    const companyId = this.state.companyId;
    if (!companyId) {
      return alert('Please enter valid value');
    }

    this.setState({ operationInProgress: true });
    try {
      const result = await api.getCompanyKycData({ companyId });

      this.setState({
        kycStatus: result.kycStatus || null,
        kycData: result.kycData || null,
        razorpayBankAccount: result.razorpayBankAccount || null
      });
    } catch (error) {
      this.setState({
        error: true,
        kycStatus: undefined,
        errorMessage:
          (error && error.response && error.response.data) || 'Failed to load'
      });
    } finally {
      this.setState({ operationInProgress: false });
    }
  };

  verifyCompanyKycDetails = async () => {
    const formData = {
      companyId: this.state.companyId,
      verify: true
    };
    this.setState({ operationInProgress: true });
    try {
      await api.toggleVerifyCompanyKycData(formData);
      this.setState({
        kycStatus: 'DONE'
      });
    } catch (error) {
      this.setState({
        error: true,
        errorMessage:
          (error && error.response && error.response.data) || 'Failed to load'
      });
    } finally {
      this.setState({ operationInProgress: false });
    }
  };

  unverifyCompanyKycDetails = async () => {
    const formData = {
      companyId: this.state.companyId,
      verify: false
    };

    this.setState({ operationInProgress: true });
    try {
      await api.toggleVerifyCompanyKycData(formData);
      this.setState({
        kycStatus: 'NOT_DONE'
      });
    } catch (error) {
      this.setState({
        error: true,
        errorMessage:
          (error && error.response && error.response.data) || 'Failed to load'
      });
    } finally {
      this.setState({ operationInProgress: false });
    }
  };

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.getCompanyKycDetails(event.target.name);
    }
  };

  renderScanCheque = () => {
    const { kycData } = this.state;

    if (!kycData || !kycData.scanCheque) {
      return;
    }

    return (
      <div>
        <DisplayStatusSection>
          <KycStatus>
            <KycStatusTitle>Scan Cheque</KycStatusTitle>
            <ScanChequeImage src={kycData.scanCheque} alt="" />
          </KycStatus>
        </DisplayStatusSection>
      </div>
    );
  };

  renderRazorpayBankAccount = () => {
    const { razorpayBankAccount } = this.state;

    if (!razorpayBankAccount) {
      return;
    }

    return (
      <div>
        <DisplayStatusSection>
          <KycStatus>
            <KycStatusTitle>Razorpay Bank Account</KycStatusTitle>
          </KycStatus>
          <KycStatusDisplay>
            <KycStatusDetails>
              <div>
                Account Number: {razorpayBankAccount.accountNumber || ''}
              </div>
              <div>Account type: {razorpayBankAccount.accountType || ''}</div>
              <div>
                Beneficiary Name: {razorpayBankAccount.beneficiaryName || ''}
              </div>
              <div>IFSC Code: {razorpayBankAccount.ifscCode || ''}</div>
            </KycStatusDetails>
          </KycStatusDisplay>
        </DisplayStatusSection>
      </div>
    );
  };

  renderKycStatusAndActionButtonsSection = () => {
    const { kycStatus, operationInProgress } = this.state;

    if (kycStatus === undefined) {
      return;
    }

    if (
      kycStatus === null ||
      kycStatus === 'PENDING_CUSTOMER' ||
      kycStatus === 'PENDING_CUSTOMER_DISABLED'
    ) {
      return (
        <div>
          <DisplayStatusSection>
            <KycStatus>
              <KycStatusTitle>KYC Status</KycStatusTitle>
            </KycStatus>
            <KycStatusDisplay>
              <KycStatusTitle>
                Company has not yet submitted KYC Documents
              </KycStatusTitle>
            </KycStatusDisplay>
          </DisplayStatusSection>
        </div>
      );
    }

    if (
      kycStatus === 'PENDING_INTERNAL' ||
      kycStatus === 'PENDING_INTERNAL_DISABLED'
    ) {
      return (
        <div>
          <DisplayStatusSection>
            <KycStatus>
              <KycStatusTitle>KYC Status</KycStatusTitle>
            </KycStatus>
            <KycStatusDisplay>
              <KycStatusTitle>
                Company has submitted KYC Documents
              </KycStatusTitle>
            </KycStatusDisplay>
          </DisplayStatusSection>
          <ActionButtons>
            <VerifyKycButton
              disabled={operationInProgress}
              onClick={() => this.verifyCompanyKycDetails()}
            >
              Verify KYC
            </VerifyKycButton>
            <UnverifyKycButton
              disabled={operationInProgress}
              onClick={() => this.unverifyCompanyKycDetails()}
            >
              Unverify KYC
            </UnverifyKycButton>
          </ActionButtons>
        </div>
      );
    }

    if (kycStatus === 'NOT_DONE') {
      return (
        <div>
          <DisplayStatusSection>
            <KycStatus>
              <KycStatusTitle>KYC Status</KycStatusTitle>
            </KycStatus>
            <KycStatusDisplay>
              <KycStatusTitle>Company KYC Incomplete</KycStatusTitle>
            </KycStatusDisplay>
          </DisplayStatusSection>
          <ActionButtons>
            <VerifyKycButton
              disabled={operationInProgress}
              onClick={() => this.verifyCompanyKycDetails()}
            >
              Verify KYC
            </VerifyKycButton>
          </ActionButtons>
        </div>
      );
    }
    if (kycStatus === 'DONE') {
      return (
        <div>
          <DisplayStatusSection>
            <KycStatus>
              <KycStatusTitle>KYC Status</KycStatusTitle>
            </KycStatus>
            <KycStatusDisplay>
              <KycStatusTitle>Company KYC Complete</KycStatusTitle>
            </KycStatusDisplay>
          </DisplayStatusSection>
          <ActionButtons>
            <UnverifyKycButton
              disabled={operationInProgress}
              onClick={() => this.unverifyCompanyKycDetails()}
            >
              Unverify KYC
            </UnverifyKycButton>
          </ActionButtons>
        </div>
      );
    }
  };

  render() {
    const { companyId, operationInProgress } = this.state;
    return (
      <CompanyKycDetailsContainer>
        <FormSection>
          <Title>Get company KYC Details</Title>
          <InputSection>
            <DetailsOfInput>
              <InputTitle>Company ID</InputTitle>
            </DetailsOfInput>
            <InputFieldWithSubmit>
              <Input
                value={companyId}
                name="companyId"
                onChange={this.updateValue}
                onKeyDown={this.handleKeyDown}
              />
              <GetCompanyKycButton
                disabled={operationInProgress}
                onClick={() => this.getCompanyKycDetails('companyId')}
              >
                Get company KYC Data
              </GetCompanyKycButton>
            </InputFieldWithSubmit>
          </InputSection>
          <div>{this.renderScanCheque()}</div>
          <div>{this.renderRazorpayBankAccount()}</div>
          <div>{this.renderKycStatusAndActionButtonsSection()}</div>
        </FormSection>
        <ResultSection id={'resultSection'}></ResultSection>
      </CompanyKycDetailsContainer>
    );
  }
}

export default CheckKycStatus;



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/CheckKycStatus/index.js